import { createSlice } from '@reduxjs/toolkit';
import {
  setNeedsToCheckCustomerAccountsShippingAddressDraft,
  setNeedsToValidateFieldsOfCustomerAccountAddressDraft,
} from './index.migrated';
import { convertToBuilderNotation } from '../../utils';

export {
  setNeedsToCheckCustomerAccountsShippingAddressDraft,
  setNeedsToValidateFieldsOfCustomerAccountAddressDraft,
};

export const shippingAddressSlice = createSlice({
  name: 'shippingAddress',
  initialState: {
    needsToCheckCustomerAccountsShippingAddressDraft: false,
    needsToValidateFieldsOfCustomerAccountAddressDraft: false,
  },
  reducers: {
    setNeedsToCheckCustomerAccountsShippingAddressDraft: (state, action) => ({
      ...state,
      needsToCheckCustomerAccountsShippingAddressDraft: action.payload,
    }),
    setNeedsToValidateFieldsOfCustomerAccountAddressDraft: (state, action) => ({
      ...state,
      needsToValidateFieldsOfCustomerAccountAddressDraft: action.payload,
    }),
  },
  extraReducers: convertToBuilderNotation({}),
});

export default shippingAddressSlice.reducer;
